import React from 'react';
import { Button } from '@cainiaofe/cn-ui';
var footer = [{
  text: '全选',
  type: 'all'
}, {
  text: '反选',
  type: 'reverse'
}, {
  text: '清空',
  type: 'clear'
}];
export default (function (props) {
  var locale = props.locale,
    count = props.count,
    _props$onChoose = props.onChoose,
    onChoose = _props$onChoose === void 0 ? function () {} : _props$onChoose;
  return /*#__PURE__*/React.createElement("div", {
    className: "cn-address-footer"
  }, Array(count).fill(0).map(function (i, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "cn-address-footer-item",
      key: i
    }, footer.map(function (btn) {
      return /*#__PURE__*/React.createElement(Button, {
        key: btn.type,
        onClick: function onClick() {
          return onChoose(index, btn.type);
        },
        className: "cn-address-footer-btn"
      }, locale[btn.type]);
    }));
  }));
});